// extracted by mini-css-extract-plugin
export default {"container":"labelled-indent_container__cpk9h","indent":"labelled-indent_indent__F1-ge"};